// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2x_Ae","header":"MessagesList_header__1J5XL","chat":"MessagesList_chat__3vBNP"};